import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Authority } from '../config/authority.constants';
import { StateStorageService } from '../config/state-storage.service';
import { AccountService } from '../services/account.service';

@Injectable()
export class AuthGuard  {
    constructor(private router: Router, public accountService: AccountService,
        private stateStorageService: StateStorageService) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {

        return this.accountService.identity().pipe(
            map(account => {
                if (account) {
                    const authorities = route.data['authorities'];
                    if (!authorities || authorities.length === 0 || this.accountService.hasAnyAuthority(authorities)) {
                        return true;
                    }

                    this.router.navigate(['site']);
                    return false;
                }

                this.stateStorageService.storeUrl(state.url);

                this.router.navigate(['/site']);
                return false;
            })
        );
    }
}
